import Modal from '@/components/Modal';
import { WalletType } from '@/interfaces/IUser';
import { loginUserToWebSite, changeWalletAddress } from '@/redux/auth';
import Web3 from 'web3';
import {
  openConnectWallet,
  selectConnectWalletModalState,
} from '@/redux/modal';
import { changeWalletConnect} from '@/redux/web3';
import { checkWeb3Instance, getWalletConnectProvider  } from '@/web3/getWeb3'
import { rootElement } from '@/utils/consts';
import { useAppDispatch, useAppSelector } from '@/utils/hooks';
import {
  StyledConnectWalletContainer,
  StyledConnectWalletText,
  StyledConnectWalletTitle,
  StyledGradientButton,
  StyledGradientButtonMetamask,
  StyledGradientButtonWalletConnect,
} from '@components/MainContent/Navbar/ConnectWallet/styled';
import { ReactComponent as Metamask } from '@icons/METAMASK.svg';
import { ReactComponent as WalletConnect } from '@icons/WalletConnect.svg';
import React from 'react';
import usePortal from 'react-useportal';

const ConnectWallet = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const connectWalletModalState = useAppSelector(selectConnectWalletModalState);

  const { Portal } = usePortal({
    bindTo: rootElement,
  });

  const getMetamask = async ()=>{
    
    const web3 = await checkWeb3Instance();
    if (web3) {
      const accounts = await web3.eth.getAccounts();
      dispatch(changeWalletAddress(accounts[0]));
      dispatch(loginUserToWebSite(WalletType.METAMASK))
    }
  };

  const getWalletConnect = async ()=> {
    const web3 = await new Web3(await getWalletConnectProvider());
    const accounts = await web3.eth.getAccounts();
    dispatch(changeWalletAddress(accounts[0]))
    dispatch(changeWalletConnect(true));
    dispatch(loginUserToWebSite(WalletType.WALLETCONNECT))
  }
  
  const clickToConnectWallet = function (event: React.MouseEvent<HTMLElement>) {
    const target = event.currentTarget as HTMLDivElement;
    const walletType = target.id as WalletType;
    if (Object.values(WalletType).includes(walletType)) {
      
      if (walletType === 'walletconnect')
    {
      getWalletConnect()
    }
    else if (walletType === 'metamask')
    {
      getMetamask()
    }
    dispatch(openConnectWallet(false));
    const isFirefox = /Firefox/i.test(navigator.userAgent);
    isFirefox ? document.body.style.overflowY = 'auto' : document.body.style.overflowY = 'overlay';
    }
  };

  const closeConnectWalletModal = function () {
    dispatch(openConnectWallet(false));
    const isFirefox = /Firefox/i.test(navigator.userAgent);
    isFirefox ? document.body.style.overflowY = 'auto' : document.body.style.overflowY = 'overlay';
  };
  return (
    <>
      {connectWalletModalState && (
        <Portal>
          <Modal closePortal={closeConnectWalletModal}>
            <StyledConnectWalletContainer>
              <StyledConnectWalletTitle>
                Connect Wallet
              </StyledConnectWalletTitle>
              <StyledConnectWalletText>
                Please choose your wallet
              </StyledConnectWalletText>
              <StyledGradientButtonMetamask
                onClick={clickToConnectWallet}
                id={WalletType.METAMASK}
                textContent=""
                svg={<Metamask />}
              />
              <StyledGradientButtonWalletConnect
                onClick={clickToConnectWallet}
                id={WalletType.WALLETCONNECT}
                textContent=""
                svg={<WalletConnect />}
              />
            </StyledConnectWalletContainer>
          </Modal>
        </Portal>
      )}
    </>
  );
};

export default ConnectWallet;
